import SearchFilter from 'components/home/messages/search-filter';
import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import type { CommunicationData } from 'types';
import { CommunicationHelper } from 'utils';

import TransferLineLogRow from './transferLineLogRow';

type FilterType = 'phone';

type TransferLineLogTableProps = {
  communicationsData: CommunicationData;
  communicationsMutate: () => Promise<CommunicationData | undefined>;
  handleErrorMessage: (errorMessage: string) => void;
  archived: boolean;
};

const TransferLineLogTable: React.FC<TransferLineLogTableProps> = ({
  communicationsData,
  communicationsMutate,
  handleErrorMessage,
  archived,
}) => {
  const [filteredData, setFilteredData] = useState(communicationsData.entry);

  useEffect(() => {
    setFilteredData(communicationsData.entry);
  }, [communicationsData.entry]);

  const handleFilterChange = ({ type: _type, value }: { type: FilterType; value: string }) => {
    if (!value) {
      setFilteredData(communicationsData.entry);
      return;
    }

    const filtered = communicationsData.entry.filter((entry) => {
      const helper = new CommunicationHelper(entry.resource);
      return helper.getMemberPhoneNumber() === value;
    });

    setFilteredData(filtered);
  };

  return (
    <div className="table-div-message">
      <SearchFilter
        filterOptions={[{ key: 'phone', text: 'Phone Number', value: 'phone', icon: 'phone' }]}
        defaultFilterType="phone"
        autoApply
        onFilterChange={handleFilterChange}
        inputLabelMap={{
          phone: 'Phone Number',
        }}
      />

      <Table basic sortable celled singleLine>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Engagement ID</Table.HeaderCell>
            <Table.HeaderCell>Phone Number 1</Table.HeaderCell>
            <Table.HeaderCell>Phone Number 2</Table.HeaderCell>
            <Table.HeaderCell>User</Table.HeaderCell>
            <Table.HeaderCell>Subject</Table.HeaderCell>
            <Table.HeaderCell>Content</Table.HeaderCell>
            <Table.HeaderCell>Date & Time</Table.HeaderCell>
            <Table.HeaderCell>Assign Member</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {filteredData.map((communication, index) => (
            <TransferLineLogRow
              key={index}
              communicationsMutate={communicationsMutate}
              communicationResource={communication.resource}
              handleErrorMessage={handleErrorMessage}
              archived={archived}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default TransferLineLogTable;
